import React, { Component } from "react";

class Settings extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div style={{ padding: "15vh" }}>
        <br></br>
        <h1 className="text-center">Settings</h1>
      </div>
    );
  }
}

export default Settings;
